// frontend/src/pages/RegisterPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const RegisterPage = () => {
    // Estados para os campos do formulário
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState(''); // Campo extra

    // Estados para controle de UI
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    // Hooks e Contexto
    const navigate = useNavigate();
    const { login } = useAuth(); // Usaremos a função login após o registro bem-sucedido

    // Função para lidar com o envio do formulário
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validação de confirmação de senha no frontend
        if (password !== confirmPassword) {
            setError('As senhas não coincidem.');
            return; // Interrompe o envio
        }

        // Validação de força da senha (exemplo simples - pode melhorar)
        if (password.length < 6) {
             setError('A senha deve ter pelo menos 6 caracteres.');
             return;
        }


        setIsLoading(true);

        try {
            // Chama a API de registro no backend
            const response = await api.post('/auth/register', {
                email,
                password, // Envia apenas a senha, não a confirmação
            });

            // Se a requisição foi bem-sucedida (status 201)
            console.log('Register API response:', response.data);

            // LOGA O USUÁRIO AUTOMATICAMENTE APÓS O REGISTRO
            // A API de registro retorna os mesmos dados que a de login (_id, email, token)
            login(response.data);

            // Redireciona para o dashboard
            navigate('/', { replace: true });

        } catch (err) {
            // Se a requisição falhar
            console.error('Erro no registro:', err);
            const errorMessage = err.response?.data?.message || 'Erro ao tentar registrar. Verifique os dados ou tente novamente.';
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        // Container principal (igual ao LoginPage)
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            {/* Card do formulário */}
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-center text-gray-900">
                    Criar Conta no Dropship Manager
                </h2>
                {/* Formulário de Registro */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Campo Email */}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isLoading}
                            className="block w-full px-3 py-2 mt-1 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70"
                            placeholder="seuemail@example.com"
                        />
                    </div>

                    {/* Campo Senha */}
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Senha</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            autoComplete="new-password" // Importante para gerenciadores de senha
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={isLoading}
                            className="block w-full px-3 py-2 mt-1 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70"
                            placeholder="Mínimo 6 caracteres"
                        />
                    </div>

                    {/* Campo Confirmar Senha */}
                    <div>
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Confirmar Senha</label>
                        <input
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            autoComplete="new-password"
                            required
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            disabled={isLoading}
                            className={`block w-full px-3 py-2 mt-1 placeholder-gray-400 border rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:opacity-70 ${
                                // Adiciona borda vermelha se as senhas não coincidirem E o campo foi tocado
                                confirmPassword && password !== confirmPassword ? 'border-red-500' : 'border-gray-300'
                            }`}
                            placeholder="Repita a senha"
                        />
                         {/* Mensagem se senhas não batem */}
                        {confirmPassword && password !== confirmPassword && (
                             <p className="mt-1 text-xs text-red-600">As senhas não coincidem.</p>
                        )}
                    </div>

                    {/* Exibição de Mensagem de Erro da API */}
                    {error && (
                        <p className="text-sm text-center text-red-600">
                            {error}
                        </p>
                    )}

                    {/* Botão de Submit */}
                    <div>
                        <button
                            type="submit"
                            disabled={isLoading || (password !== confirmPassword && confirmPassword !== '')} // Desabilita se carregando OU senhas não batem
                            className="relative flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md group hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoading ? 'Registrando...' : 'Criar Conta'}
                        </button>
                    </div>
                </form>

                {/* Link para Login */}
                <p className="mt-6 text-sm text-center text-gray-600">
                    Já tem uma conta?{' '}
                    <Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-500">
                        Entrar
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default RegisterPage;